//TODO : Refactor after ai
/**
 * Aufträge & Abrechnung: Ausmassfreigabe → abrechnungsbereit → Rechnung nach Bexio → Zahlung → Nachkalkulation.
 * Deckungsbeitrag aus Erlös, Material (Einstandspreis), Stunden (Kostensatz) und Fahrzeugen (ANNAHMEN C4, C11).
 */
import { useNavigate, useParams } from "react-router-dom";
import { useDatenStore } from "@app/store";
import {
  datensatz,
  datensaetze,
  heute,
  nachkalkulationAusAuftrag,
  rechnungAusAuftrag,
  zahlungseingang,
} from "@shared/demo-data/viacid";
import { datumCH, fr, mit, num, str, viele, zahl, ziel } from "./lib";
import {
  Beispiel,
  Hinweis,
  Karte,
  Kennzahl,
  Knopf,
  Pille,
  Seite,
  Zeile,
} from "./ui";
import { ActionLeiste } from "./ActionLeiste";
import { objektKlasse as klasseVon } from "@shared/demo-data/viacid";

export function AuftraegeListePage() {
  const b = useDatenStore((s) => s.bestand);
  const nav = useNavigate();
  const liste = datensaetze(b, "auftrag");
  return (
    <Seite
      titel="Aufträge"
      untertitel="Dienstleistung und Handel · vom Auftrag bis zur bezahlten Rechnung"
    >
      <Karte>
        <table className="vc-table">
          <thead>
            <tr>
              <th>Nr.</th>
              <th>Auftrag</th>
              <th>Kunde</th>
              <th>Art</th>
              <th>Ausführung</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {liste.map((a) => (
              <tr
                key={a.id}
                className="link"
                onClick={() => nav(`/app/auftraege/${a.id}`)}
              >
                <td>{a.kennung}</td>
                <td>{a.titel}</td>
                <td>{ziel(b, a, "auftrag-von-kunde", "kunde")?.titel}</td>
                <td>{str(a.werte.auftragsart)}</td>
                <td>
                  {a.werte.ausfuehrungszeitraumVon
                    ? `${datumCH(a.werte.ausfuehrungszeitraumVon)} – ${datumCH(a.werte.ausfuehrungszeitraumBis)}`
                    : datumCH(a.werte.liefertermin)}
                </td>
                <td>
                  <Pille status={a.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Karte>
    </Seite>
  );
}

export function AuftragPage() {
  const { id = "" } = useParams();
  const b = useDatenStore((s) => s.bestand);
  const rolle = useDatenStore((s) => s.rolle);
  const aendern = useDatenStore((s) => s.aendern);
  const anwenden = useDatenStore((s) => s.anwenden);
  const nav = useNavigate();
  const a = datensatz(b, "auftrag", id);
  if (!a) return <Hinweis ton="red">Auftrag nicht gefunden.</Hinweis>;
  const kunde = ziel(b, a, "auftrag-von-kunde", "kunde");
  const positionen = mit(
    b,
    "auftragsposition",
    "auftragsposition-gehoert-zu-auftrag",
    a.id
  );
  const einsaetze = mit(b, "einsatz", "einsatz-fuer-auftrag", a.id);
  const protokolle = mit(
    b,
    "ausmassprotokoll",
    "ausmassprotokoll-zu-auftrag",
    a.id
  );
  const rechnungen = mit(b, "rechnung", "rechnung-zu-auftrag", a.id);
  const lieferungen = mit(b, "lieferung", "lieferung-zu-auftrag", a.id);
  const bewegungen = mit(
    b,
    "materialbewegung",
    "materialbewegung-fuer-auftrag",
    a.id
  );
  const nachkalk = datensaetze(b, "nachkalkulation").find(
    (n) => n.bezuege["nachkalkulation-zu-auftrag"] === a.id
  );
  const extern = rolle === "KO" || rolle === "HA";

  const erloes = positionen.reduce(
    (s, p) => s + num(p.werte.menge) * num(p.werte.einzelpreis),
    0
  );
  const material = bewegungen
    .filter((m) => str(m.werte.bewegungsart) === "Verbrauch")
    .reduce((s, m) => {
      const ar = ziel(b, m, "materialbewegung-betrifft-artikel", "artikel");
      return s + num(m.werte.menge) * num(ar?.werte.einstandspreis);
    }, 0);
  const stundenKosten = einsaetze
    .flatMap((e) => mit(b, "rapportzeile", "rapportzeile-zu-einsatz", e.id))
    .filter(
      (z) => str(z.werte.zeilenart) === "Arbeitszeit" || !z.werte.zeilenart
    )
    .reduce((s, z) => {
      const m = ziel(b, z, "rapportzeile-von-mitarbeiter", "mitarbeiter");
      return s + num(z.werte.stunden) * (num(m?.werte.stundenkostensatz) || 80);
    }, 0);
  const fahrzeugKosten = einsaetze
    .filter((e) => e.status === "Ausgeführt")
    .reduce((s, e) => {
      const taetigkeit = mit(b, "rapportzeile", "rapportzeile-zu-einsatz", e.id)
        .filter((z) => str(z.werte.zeilenart) !== "Arbeitszeit")
        .reduce((t, z) => t + num(z.werte.stunden), 0);
      const stunden = taetigkeit || 4;
      return (
        s +
        viele(e.bezuege["einsatz-nutzt-fahrzeug"]).reduce(
          (t, fid) =>
            t +
            stunden *
              num(datensatz(b, "fahrzeug", fid)?.werte.stundenkostensatz),
          0
        )
      );
    }, 0);
  const db = erloes - material - stundenKosten - fahrzeugKosten;
  const verbrauchKg = bewegungen
    .filter((m) => str(m.werte.bewegungsart) === "Verbrauch")
    .reduce((s, m) => {
      const ar = ziel(b, m, "materialbewegung-betrifft-artikel", "artikel");
      return s + num(m.werte.menge) * (num(ar?.werte.gebindegroesse) || 1);
    }, 0);
  const mengeGesamt = positionen.reduce((s, p) => s + num(p.werte.menge), 0);
  const offenesAusmass = protokolle.find((p) => p.status !== "Freigegeben");
  const freigegeben = protokolle.some((p) => p.status === "Freigegeben");

  return (
    <Seite
      titel={`${a.kennung} · ${a.titel}`}
      untertitel={
        <>
          {kunde?.titel} · {str(a.werte.auftragsart)} ·{" "}
          {datumCH(a.werte.auftragsdatum)} <Pille status={a.status} />
        </>
      }
      aktionen={
        <>
          {kunde && (
            <Knopf onClick={() => nav(`/app/kunden/${kunde.id}`)}>Kunde</Knopf>
          )}
          {!extern && a.status === "Erteilt" && (
            <Knopf
              onClick={() =>
                aendern(
                  { slug: "auftrag", id: a.id, status: "Freigegeben" },
                  "Auftrag freigegeben – Disposition kann planen."
                )
              }
            >
              Freigeben
            </Knopf>
          )}
          {!extern &&
            a.status === "Freigegeben" &&
            a.werte.auftragsart === "Dienstleistung" && (
              <Knopf onClick={() => nav("/app/planung")}>Disponieren</Knopf>
            )}
          {extern && offenesAusmass && (
            <Knopf
              art="primary"
              onClick={() =>
                aendern(
                  {
                    slug: "ausmassprotokoll",
                    id: offenesAusmass.id,
                    status: "Freigegeben",
                    werte: { freigegebenAm: heute() },
                  },
                  "Ausmass freigegeben – abrechnungsrelevante Daten liegen vor."
                )
              }
            >
              Ausmass freigeben
            </Knopf>
          )}
          {!extern &&
            ["Erteilt", "Freigegeben"].includes(a.status ?? "") &&
            (freigegeben || a.werte.auftragsart !== "Dienstleistung") && (
              <Knopf
                art="primary"
                onClick={() =>
                  aendern(
                    {
                      slug: "auftrag",
                      id: a.id,
                      status: "Abrechnungsbereit",
                      werte: { abrechnungsbereitSeit: heute() },
                    },
                    "Auftrag abrechnungsbereit."
                  )
                }
              >
                Abrechnungsbereit
              </Knopf>
            )}
          {!extern &&
            a.status === "Abrechnungsbereit" &&
            rechnungen.length === 0 && (
              <Knopf
                art="primary"
                onClick={() => anwenden(rechnungAusAuftrag(b, a.id))}
              >
                Rechnung in Bexio erstellen
              </Knopf>
            )}
          {!extern && rechnungen.some((r) => r.status !== "Bezahlt") && (
            <Knopf
              onClick={() =>
                anwenden(
                  zahlungseingang(
                    b,
                    rechnungen.find((r) => r.status !== "Bezahlt")!.id
                  )
                )
              }
            >
              Zahlungseingang (Bexio)
            </Knopf>
          )}
          {!extern && !nachkalk && rechnungen.length > 0 && (
            <Knopf onClick={() => anwenden(nachkalkulationAusAuftrag(b, a.id))}>
              Nachkalkulation
            </Knopf>
          )}
          {klasseVon("auftrag") && (
            <ActionLeiste
              klasse={klasseVon("auftrag")!}
              satz={a}
              ausser={[
                "Auftrag freigeben",
                "nachkalkulation",
                "Ausmaß freigeben",
                "Auftragsposition anlegen",
              ]}
              verwandt={[
                {
                  slug: "reklamation",
                  rel: "reklamation-zu-auftrag",
                  mit: kunde
                    ? { "reklamation-von-kunde": kunde.id }
                    : undefined,
                },
              ]}
            />
          )}
        </>
      }
    >
      {offenesAusmass && !extern && (
        <div style={{ marginBottom: 16 }}>
          <Hinweis>
            Ausmassprotokoll wartet auf Kundenfreigabe – zum Simulieren „Ansicht
            als Kunde (Kommune)“.
          </Hinweis>
        </div>
      )}
      <div className="vc-grid c4" style={{ marginBottom: 16 }}>
        <Kennzahl label="Erlös laut Auftrag" wert={fr(erloes)} />
        <Kennzahl
          label="Material + Stunden + Fahrzeuge"
          wert={fr(material + stundenKosten + fahrzeugKosten)}
          hint={
            <>
              {fr(material)} · {fr(stundenKosten)} · {fr(fahrzeugKosten)}{" "}
              <Beispiel />
            </>
          }
        />
        <Kennzahl
          label="Deckungsbeitrag"
          wert={fr(db)}
          hint={erloes ? `${Math.round((100 * db) / erloes)} % Marge` : ""}
          ton={db < 0 ? "warn" : "accent"}
        />
        <Kennzahl
          label="Verbrauch je Einheit"
          wert={mengeGesamt ? `${zahl(verbrauchKg / mengeGesamt)} kg` : "—"}
          hint="Lernwert für die nächste Kalkulation"
        />
      </div>
      <div className="vc-grid main-side">
        <div className="vc-grid">
          <Karte titel="Positionen">
            <table className="vc-table">
              <thead>
                <tr>
                  <th>Pos.</th>
                  <th>Bezeichnung</th>
                  <th className="num">Menge</th>
                  <th className="num">Ausgeführt</th>
                  <th className="num">Einzelpreis</th>
                  <th className="num">Betrag</th>
                </tr>
              </thead>
              <tbody>
                {positionen.map((p) => (
                  <tr key={p.id}>
                    <td>{str(p.werte.positionsnummer)}</td>
                    <td>{str(p.werte.bezeichnung)}</td>
                    <td className="num">
                      {num(p.werte.menge)} {str(p.werte.einheit)}
                    </td>
                    <td className="num">
                      {p.werte.ausgefuehrteMenge
                        ? `${num(p.werte.ausgefuehrteMenge)} ${str(p.werte.einheit)}`
                        : "—"}
                    </td>
                    <td className="num">{fr(num(p.werte.einzelpreis))}</td>
                    <td className="num">
                      {fr(num(p.werte.menge) * num(p.werte.einzelpreis))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Karte>
          {a.werte.auftragsart === "Dienstleistung" ? (
            <Karte titel="Einsätze">
              <div className="vc-list">
                {einsaetze.map((e) => (
                  <Zeile
                    key={e.id}
                    titel={e.titel}
                    meta={`${datumCH(e.werte.einsatzdatum)} · ${str(e.werte.zeitslot)} · ${ziel(b, e, "einsatz-gefuehrt-von-mitarbeiter", "mitarbeiter")?.titel ?? ""}`}
                    rechts={<Pille status={e.status} />}
                    zu={`/app/baustelle/${e.id}`}
                  />
                ))}
                {einsaetze.length === 0 && (
                  <div className="sub">Noch nicht disponiert.</div>
                )}
              </div>
            </Karte>
          ) : (
            <Karte titel="Lieferungen">
              <div className="vc-list">
                {lieferungen.map((l) => (
                  <Zeile
                    key={l.id}
                    titel={l.titel}
                    meta={`${str(l.werte.versandart)} · ${datumCH(l.werte.liefertermin)} · ${str(l.werte.transportdienstleister)}`}
                    rechts={<Pille status={l.status} />}
                    zu={`/app/daten/lieferung/${l.id}`}
                  />
                ))}
              </div>
            </Karte>
          )}
          <Karte
            titel="Material"
            sub="Entnahme, Verbrauch, Rückgabe je Auftrag"
          >
            <div className="vc-list">
              {bewegungen.map((m) => (
                <Zeile
                  key={m.id}
                  titel={m.titel}
                  meta={`${str(m.werte.bewegungsart)} · ${num(m.werte.menge)} ${str(m.werte.einheit)} · ${datumCH(m.werte.zeitpunkt)}`}
                  rechts={<Pille status={m.status} />}
                />
              ))}
              {bewegungen.length === 0 && (
                <div className="sub">Keine Materialbewegungen.</div>
              )}
            </div>
          </Karte>
        </div>
        <div className="vc-grid">
          <Karte titel="Ausmass & Freigabe">
            <div className="vc-list">
              {protokolle.map((p) => (
                <Zeile
                  key={p.id}
                  titel={p.titel}
                  meta={`${datumCH(p.werte.ausmassdatum)} · ${mit(b, "ausmassposition", "ausmassposition-gehoert-zu-ausmassprotokoll", p.id).length} Positionen`}
                  rechts={<Pille status={p.status} />}
                  zu={`/app/daten/ausmassprotokoll/${p.id}`}
                />
              ))}
              {protokolle.length === 0 && (
                <div className="sub">
                  Entsteht beim Abschluss des Einsatzes.
                </div>
              )}
            </div>
          </Karte>
          <Karte
            titel="Rechnung (Bexio-Spiegel)"
            sub="Positionen, Buchung und Mahnlauf in Bexio"
          >
            <div className="vc-list">
              {rechnungen.map((r) => (
                <Zeile
                  key={r.id}
                  titel={`${r.kennung ?? r.titel}`}
                  meta={`${datumCH(r.werte.rechnungsdatum)} · fällig ${datumCH(r.werte.faelligkeitsdatum)} · ${fr(num(r.werte.betragBrutto))}${r.werte.bezahltAm ? ` · bezahlt ${datumCH(r.werte.bezahltAm)}` : ""}`}
                  rechts={<Pille status={r.status} />}
                  zu={`/app/daten/rechnung/${r.id}`}
                />
              ))}
              {rechnungen.length === 0 && (
                <div className="sub">Noch keine Rechnung.</div>
              )}
            </div>
          </Karte>
          {nachkalk && (
            <Karte
              titel="Nachkalkulation"
              rechts={<Pille status={nachkalk.status} />}
            >
              <p style={{ margin: 0, fontSize: "0.85rem" }}>
                {str(nachkalk.werte.beurteilung) ||
                  `Deckungsbeitrag ${fr(db)} (${erloes ? Math.round((100 * db) / erloes) : 0} %).`}
              </p>
              <div className="sub" style={{ marginTop: 6 }}>
                Stichtag {datumCH(nachkalk.werte.stichtag)} ·{" "}
                {str(nachkalk.werte.konsequenzenFuerAngebote) ||
                  "Verbrauchswert fliesst in den Durchschnitt je Massnahmenart."}
              </div>
            </Karte>
          )}
        </div>
      </div>
    </Seite>
  );
}
